import Vue from "vue";
import VueMeta from "vue-meta";

// Prevent multiple registrations and redefinition errors
if (!Vue._installedPlugins || !Vue._installedPlugins.includes(VueMeta)) {
  try {
    Vue.use(VueMeta, {
      keyName: "metaInfo",
      attribute: "data-vue-meta",
      ssrAttribute: "data-vue-meta-server-rendered",
      tagIDKeyName: "vmid",
      refreshOnceOnNavigation: true,
    });
  } catch (error) {
    console.warn("Vue Meta plugin failed to initialize:", error);
  }
}
